import { Flex, Text } from "@mantine/core";

import { ImportType } from "../../graphql/generated.ts";

const invoicesImportCsvTemplateHeaders = [
  { key: "invoiceNumber", label: "Invoice Number" },
  { key: "customer", label: "Customer" },
  { key: "totalInvoice", label: "Total Invoice" },
  { key: "totalPaid", label: "Total Paid" },
  { key: "totalAmountDue", label: "Total Amount Due" },
  { key: "invoiceDueDate", label: "Invoice Due Date" },
  { key: "paymentStatus", label: "Payment Status" },
  { key: "salesName", label: "Sales Name" },
  { key: "salesTeamName", label: "Sales Team Name" },
  { key: "bastDate", label: "BAST Date" },
  { key: "paymentType", label: "Payment Type" },
  { key: "paymentMethod", label: "Payment Method" },
];

export const invoicesImportModalOptions = {
  title: "Upload Invoice Data",
  type: ImportType.Invoice,
  information: (
    <Flex direction="column">
      <Text>
        Payment Status field will receive following options: &quot;in
        payment&quot;, &quot;not paid&quot;, &quot;paid&quot;,
        &quot;partial&quot;.
      </Text>
      <Text>
        Payment Type field will receive following options: &quot;COD&quot;,
        &quot;CBD&quot;, &quot;TOP&quot;.
      </Text>
      <Text>
        Payment Method field will receive following options:
        &quot;TRANSFER&quot;, &quot;GIRO&quot;, &quot;CHECK&quot;,
        &quot;LC&quot;, &quot;SKBDN&quot;.
      </Text>
      <Text>Dates should be in ISO format (YYYY-MM-DD).</Text>
    </Flex>
  ),
  buttonVariant: "outlineBlue",
  buttonText: "Upload Invoice",
  csvTemplateFilename: "upload_invoices_template.csv",
  csvTemplateHeaders: invoicesImportCsvTemplateHeaders,
};

const paymentsImportCsvTemplateHeaders = [
  { key: "invoiceNumber", label: "Invoice Number" },
  { key: "amount", label: "Amount" },
  { key: "paymentMethod", label: "Payment Method" },
  { key: "paidAt", label: "Paid At" },
  { key: "notes", label: "Notes" },
];

export const paymentsImportModalOptions = {
  title: "Upload Payment Data",
  type: ImportType.Payment,
  information: (
    <Flex direction="column">
      <Text>
        Payment Method field will receive following options:
        &quot;TRANSFER&quot;, &quot;GIRO&quot;, &quot;CHECK&quot;,
        &quot;LC&quot;, &quot;SKBDN&quot;.
      </Text>
      <Text>Dates should be in ISO format (YYYY-MM-DD).</Text>
    </Flex>
  ),
  warning: (
    <Text>
      The imported data will replace and update all the invoice payment data
    </Text>
  ),
  buttonVariant: "outlineBlue",
  buttonText: "Upload Payment",
  csvTemplateFilename: "upload_payments_template.csv",
  csvTemplateHeaders: paymentsImportCsvTemplateHeaders,
};
